module.exports = __webpack_public_path__ + "img/shield with a cross.f76d49c5.svg";